import React from 'react';

import JobsListSubPage from '../../../js/pages/JobsListPage/SubPage';
import newGrad from '../../../js/pages/JobsListPage/newGradJobs';
import {makeStaticPaths, makeStaticProps} from '../../../js/pages/JobsListPage/staticRoutes';

const Page = ({slug}) => <JobsListSubPage role={newGrad} slug={slug} />;

export default Page;

export const getStaticProps = makeStaticProps(newGrad);
export const getStaticPaths = makeStaticPaths(newGrad);
